import React from "react";
import { Grid, Icon } from "semantic-ui-react";

function Error404() {
	return (
		<Grid centered style={{ height: "100vh", width: "100vw" }}>
			<Grid.Column verticalAlign="middle">
				<Icon name="broken chain" size="huge" />
				<p style={{ marginTop: "20px", fontSize: "18px" }}>
					Oops. <br /> Link is bwoken.
				</p>
			</Grid.Column>
		</Grid>
	);
}

export default Error404;
